module.exports = __webpack_public_path__ + "static/media/mosip.5c362e0c.png";